import axios from 'axios';
import { MainThemeData } from '../../interfaces/theme';
import { getApiBaseUrl } from '../../config/apiBase';
import api from '../index';

const blobThemeBase =
    process.env.REACT_APP_BLOB_THEME_API_URL && process.env.REACT_APP_BLOB_THEME_API_URL.trim() !== ''
        ? process.env.REACT_APP_BLOB_THEME_API_URL.trim()
        : getApiBaseUrl();

const BLOB = axios.create({
    baseURL: blobThemeBase,
    headers: {
        common: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    },
});

/*List Themes */
const fetchThemes = (companyId: string) => {
    return api.get(`/theme-list?companyId=${companyId}`);
};

/*Get Activ Company Theme */
const fetchCompanyTheme = () => {
    return api.get('/theme');
};

/*Get Theme by Id */
const fetchThemeById = (themeId: string) => {
    return api.get(`/theme/${themeId}`);
};

/*Create Theme*/
const createTheme = (body: MainThemeData) => {
    return api.post('/theme',
        {
            name: body.name,
            value: JSON.stringify(body.value),
            companyId: body.companyId
        }
    );
};

/*Publish Theme */
const publishTheme = (themeId: string) => {
    return api.put(`/theme/publish/${themeId}`);
};

/*Delete Theme*/
const deleteTheme = (themeId: string) => {
    return api.delete(`/theme/${themeId}`);
};

/*Restore Theme*/
const restoreToDefault = (companyId: string) => {
    return api.post(`/theme/restore/${companyId}`);
};

/* Fetch Blob*/
const fetchBlobTheme = (id: string, uid: string) => {
    return BLOB.get(`/${id}/${uid}`);
};

/* Img Upload */
const uploadImage = (options: any, data: any) => {
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            Accept: 'text/plain',
        },
    };

    return api.post('/theme/asset', data, config);
};

/* Change theme */
const updateTheme = (themeId: string, body: MainThemeData) => {
    return api.put(`/theme/${themeId}`, { name: body.name, value: JSON.stringify(body.value) });
};

const ThemeAPI = {
    fetchThemes,
    createTheme,
    fetchThemeById,
    publishTheme,
    fetchCompanyTheme,
    uploadImage,
    fetchBlobTheme,
    deleteTheme,
    updateTheme,
    restoreToDefault,
};

export default ThemeAPI;
